import { IMiddlewareNext, IException } from '../common/common.types'
import { PCRConstants } from '../features/pcr/store/pcr.constants'
import { ZollApiConstants } from '../features/zollApi/store/zollApi.constants'
import Logger from '../services/logger.service'

export const exceptionHandlerMiddleware = <T extends IException>() => (next: IMiddlewareNext<T>) => (action: T): void => {
  if (action.type === PCRConstants.THROW_PCR_EXCEPTION || action.type === ZollApiConstants.THROW_API_EXCEPTION || action.type === PCRConstants.CRUD_PCR_EXCEPTION) {
    Logger.error(action.exception)
  }
  next(action)
}
